import NProgress from 'nprogress';

const instance =  NProgress.configure({
    showSpinner: false,
    trickleSpeed: 200});

export default instance;